import { render } from "./TableMobileSort.vue?vue&type=template&id=76268b71"
import script from "./TableMobileSort.vue?vue&type=script&lang=js"
export * from "./TableMobileSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__